<template>
    <div v-if="rows.length > 0" class="important-disclosure-container">
        <div class="important-disclosure-button font" @click="isOpen = true">
            <i class="fa fas fa-circle-info" />
            <span>{{ buttonText }}</span>
        </div>
        <div v-if="isOpen" class="content-container">
            <div class="content-wrapper">
                <div class="header-container">
                    <div v-if="header" class="header" v-html="$prismic.asHtml(header)" />
                    <i class="fa fa-light fa-xmark fa-xl close-button" @click="isOpen = false" />
                </div>
                <div class="content-inner">
                    <expander v-for="row in rows" :key="row.label" :label="row.label" class="expander font">
                        <div slot="label" class="label">
                            <i :class="`fa ${row.icon}`" />
                            {{ row.label }}
                        </div>
                        <div class="rich-text" v-html="$prismic.asHtml(row.text)" />
                    </expander>
                </div>
            </div>
            <div class="overlay" @click="isOpen = false" />
        </div>
    </div>
</template>

<script>
import Expander from '@/components/Expander.vue';

export default {
    components: {
        Expander,
    },
    props: {},
    data() {
        return {
            settings: this.$store.state.settings,
            isOpen: false,
        };
    },
    computed: {
        buttonText() {
            return this.settings.important_disclosure_button;
        },
        header() {
            const header = this.settings.important_disclosure_header;
            return this.$validateText(header) ? header : null;
        },
        rows() {
            return (this.settings.important_disclosure_rows || [])
                .filter(row => this.$validateText(row.label) && this.$validateText(row.text));
        },
    }
};
</script>

<style lang="scss" scoped>
.important-disclosure-container {
    .important-disclosure-button {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        cursor: pointer;
        font-weight: bold;
        span {
            text-decoration: underline;
        }
    }

    .content-container {
        position: relative;
        
        .content-wrapper {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 90%;
            height: 75vh;
            display: flex;
            flex-direction: column;
            overflow: hidden;
            background: #fff;
            @include border-radius(3px);
            z-index: 3;
            overscroll-behavior: contain;

            @include device(pad) {
                width: 500px;
                height: 500px;
            }
            .header-container {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                @include spacing(padding,6,(left,right));
                @include spacing(padding,4,top);
                @include spacing(padding,2,bottom);
                @include border(bottom, 2px, rgba(0,0,0,.03));
                
                .header {
                    color: $green;
                }
                .close-button {
                    cursor: pointer;
                }
            }

            .content-inner {
                width: 100%;
                max-height: 100%;
                @include spacing(padding,4,(left,right));
                @include spacing(padding,2,top);
                overflow-y: auto;
                overscroll-behavior: contain;
                scrollbar-width: thin;
                scrollbar-gutter: stable both-edges;

                .expander::v-deep {
                    .label {
                        @include flex();
                        flex-wrap: nowrap;
                        gap: 0.5rem;
                    }

                    .expand-row__content {
                        .rich-text {
                            * {
                                &:first-child {
                                    @include spacing(margin,0,top);
                                }
                            }
                            ul {
                                padding-left: 6px;
                            }
                        }
                    }
                }
            }
        }

        .overlay {
            position: fixed;
            top: 0;
            left: 0;
            height: 100vh;
            width: 100vw;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 2;
        }

    }
}

</style>